export const GARLIC_CRUST_SEASONING_CODE = "GOB";
export const PARMESAN_CRUST_SEASONING_CODE = "PARM";

export const NO_CRUST_SEASONING_OPTION = "NO_SEASONING";
export const GARLIC_CRUST_SEASONING_OPTION = "GARLIC_CRUST_SEASONING";
export const PARMESAN_GARLIC_CRUST_SEASONING_OPTION =
  "PARMESAN_GARLIC_CRUST_SEASONING";

export const SEASONING_OPTIONS = Object.freeze({
  GARLIC_CRUST: Object.freeze({
    code: GARLIC_CRUST_SEASONING_OPTION,
    nameKey: "food:seasonings.garlic_crust_seasoning",
  }),
  PARMESAN_GARLIC_CRUST: Object.freeze({
    code: PARMESAN_GARLIC_CRUST_SEASONING_OPTION,
    nameKey: "food:seasonings.parmessan_garlic_crust_seasoning",
  }),
  NO_SEASONING: Object.freeze({
    code: NO_CRUST_SEASONING_OPTION,
    nameKey: "food:seasonings.no_crust_seasoning",
  }),
});
